import * as React from 'react';
import {paginate} from '../../util/paginate';
import {userData} from '../../util/userData';
import {DeleteConfirmationModal} from './lib/DeleteConfirmationModal';
import {
  changeActiveStatus,
  checkForAssignedActionAlerts,
  flipNotifyUser,
  getActionAlertInfo,
  updatePassword
} from './lib/http';
import {SearchUserForm} from './lib/SearchUserForm';
import {UpdatePasswordModal} from './lib/UpdatePasswordModal';
import {UsersList} from './lib/UsersList';
import {filterUsers, redirectToUrl} from './lib/utils';

interface IProps {
  users: IManagedUser[];
  hideActionAlertDashboardCount: boolean
}
interface IState {
  users: IManagedUser[];
  isDeleteConfirmationModalOpen: boolean
  isUpdatePasswordModalOpen: boolean
  selectedUser?: IManagedUser
  searchNeedle: string
  isCurrentProjectChecked: boolean
}

export class UserAdministrationContainer extends React.Component<IProps, IState> {
  state: IState = {
    users: [],
    isDeleteConfirmationModalOpen: false,
    isUpdatePasswordModalOpen: false,
    searchNeedle: '',
    isCurrentProjectChecked: true,
  };

  componentDidMount() {
    const managedUsers = this.props.users.map((user) => {
      user.notificationOn = user.rn.toLowerCase() !== "no"
      user.adminBadgeOn = user.isAdmin.toLowerCase() !== "no"
      return user
    })
    this.setState({ users: managedUsers }, () => {
      getActionAlertInfo().then((data: IDashboardCount[]) => {
        const userIdsInActionAlertData = data.reduce((acc, cur) => {
          return [... acc, cur.user_id]
        }, [])
        let { users } = this.state
        users = users.map((u) => {
          if (userIdsInActionAlertData.includes(u.id))
            u.actionAlertInfo = data.find(item => item.user_id === u.id)
          return u
        })
        this.setState({ users })
      })
    });
  }

  flipNotifyUser(userId: number) {
    let { users } = this.state;
    let notificationOn = false

    users = users.map(user => {
      if (user.id === userId) {
        notificationOn = !user.notificationOn
        user.notificationOn = notificationOn;
      }
      return user
    })

    flipNotifyUser(userId, notificationOn).then(success => {
      if (success)
        this.setState({users})
    })

  }

  popupDeleteUserModal(user: IManagedUser) {
    let selectedUser = user
    checkForAssignedActionAlerts(selectedUser.id).then(count => {
      selectedUser.hasAssignedActionAlerts = count > 0
      this.setState({ selectedUser })
      this.setState({ isDeleteConfirmationModalOpen: true })
    })
  }

  openUpdatePasswordModal(user: IManagedUser) {
    this.setState({ selectedUser: user })
    this.setState({ isUpdatePasswordModalOpen: true })
  }

  dismissModal(modalName: 'deleteUser' | 'updatePassword') {
    switch (modalName) {
      case 'deleteUser':
        this.setState({ isDeleteConfirmationModalOpen: false })
        break
      case 'updatePassword':
        this.setState({ isUpdatePasswordModalOpen: false })
    }
  }

  inactivateUser(userId: number) {
    let { users } = this.state;

    users = users.filter(user => user.id !== userId)
    changeActiveStatus(userId).then(success => {
      if (success)
        this.setState({ users, isDeleteConfirmationModalOpen: false })
    })
  }

  updateUserPassword(userId: number, password: string) {
    updatePassword(userId, password).then(success => {
      if (success) this.setState({ isUpdatePasswordModalOpen: false })
    })
  }

  editUser(userId: number) {
    // @ts-ignore
    userData.storeUserDataInSession('edit_user_id', userId)
    redirectToUrl('user_manage');
  }

  handleSearch(needle: string) {
    this.setState({searchNeedle: needle})
  }

  handleCheckboxToggle() {
    let { isCurrentProjectChecked } = this.state
    isCurrentProjectChecked = !isCurrentProjectChecked
    this.setState({ isCurrentProjectChecked })
  }

  render() {
    const { hideActionAlertDashboardCount } = this.props
    const {
      users,
      selectedUser,
      isDeleteConfirmationModalOpen,
      isUpdatePasswordModalOpen,
      searchNeedle,
      isCurrentProjectChecked,
    } = this.state;

    const filteredUsers = filterUsers(users, searchNeedle, isCurrentProjectChecked)
    const paginatedUsers = paginate(filteredUsers, 1, 50)

    return (
      <div>
        <SearchUserForm
          onUsernameNeedleChange={(needle) => {this.handleSearch(needle)}}
          onCheckboxToggle={() => { this.handleCheckboxToggle() }}
          isCurrentProjectChecked={ isCurrentProjectChecked }
          needle={searchNeedle}
        />
        <UsersList
          hideActionAlertDashboardCount = { hideActionAlertDashboardCount }
          users={filteredUsers}
          flipNotifyUser={(userId) => {
            this.flipNotifyUser(userId);
          }}
          editUser={(userId) => {
            this.editUser(userId);
          }}
          popupDeleteUserModal={(user) => {
            this.popupDeleteUserModal(user);
          }}
          openUpdatePasswordModal={(user) => {
            this.openUpdatePasswordModal(user);
          }}
        />
        <DeleteConfirmationModal
          selectedUser={selectedUser}
          isOpen={isDeleteConfirmationModalOpen}
          dismissDeleteUserModal={() => {
            this.dismissModal("deleteUser");
          }}
          inactivateUser={(userId) => {
            this.inactivateUser(userId);
          }}
        />
        <UpdatePasswordModal
          dismissModal={() => {
            this.dismissModal("updatePassword");
          }}
          updatePassword={(password) => {
            this.updateUserPassword(selectedUser.id, password);
          }}
          isOpen={isUpdatePasswordModalOpen}
        />
      </div>
    );
  }
}

